const styles = (theme) => ({
  paymentLabel: {
    paddingTop: theme.spacing(1),
  },
  paymentValue: {
    color: theme.color.grey_75,
  },
  icon: {
    fontSize: 30,
    marginRight: theme.spacing(1),
    height: 'auto',
  },
});

export default styles;
